import React from "react";
import { Icon } from "antd";
import { ESTILOS_ESTABLECIMIENTO } from "./constants";
import { formatCurrency, formatNumber } from "./utils";

export default function ListaEstablecimientos(props) {
    const moneda = props.moneda || "PEN";
    const datos = props.datos || [];
    // Sin informacion se muestra una fila en 0 en vez de dejar el panel vacio.
    const items = datos.length > 0
        ? datos
        : [{ nombre: "Sin información", total: 0, porcentaje: 0, ...ESTILOS_ESTABLECIMIENTO[0] }];

    return (
        <div className="resumen-establecimientos">
            {items.map((item) => (
                <div className="resumen-establecimiento" key={item.nombre}>
                    <div className="resumen-establecimiento-icon" style={{ backgroundColor: item.fondo, color: item.color }}>
                        <Icon type="shop" />
                    </div>
                    <span className="resumen-establecimiento-nombre" title={item.nombre}>{item.nombre}</span>
                    <span className="resumen-establecimiento-monto">{formatCurrency(item.total, moneda)}</span>
                    <span className="resumen-establecimiento-pct">({formatNumber(item.porcentaje, 0)}%)</span>
                </div>
            ))}
        </div>
    );
}
